/**
 * @fileoverview Truncate tool-call result strings for inline UI / log lines.
 *
 * @purpose Keeps **`KorvoChat.tsx`** smaller for CRAP tooling; pure function with stable coverage.
 * @usage **`buildToolCallContent`** and any tool-status formatter pass **`result`** from **`ToolCall`**.
 * @ownership KorvoChat UI helpers
 * @dependencies None
 * @restrictions DO NOT mask errors — only length shaping for display.
 */

const TOOL_RESULT_UI_MAX = 220
const TOOL_RESULT_UI_TAIL = 217

/** Truncate a tool **`result`** string for composer / thread inline text (matches prior KorvoChat behavior). */
export function summarizeToolCallResultForUi(result?: string): string {
  if (!result) {
    return ''
  }
  return result.length > TOOL_RESULT_UI_MAX ? `${result.slice(0, TOOL_RESULT_UI_TAIL)}…` : result
}
